
import React from 'react';
import { Switch } from '@/components/ui/switch';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { Pencil } from 'lucide-react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { AutomatedUpdate } from './types';

interface UpdatesTableProps {
  updates: AutomatedUpdate[];
  selectedUpdates: number[];
  onCheckboxChange: (checked: boolean, id: number) => void;
  onToggleActive: (id: number, isActive: boolean) => void;
  onEdit: (update: AutomatedUpdate) => void;
}

export const UpdatesTable: React.FC<UpdatesTableProps> = ({
  updates,
  selectedUpdates,
  onCheckboxChange,
  onToggleActive,
  onEdit,
}) => {
  const getFrequencyLabel = (frequency: string) => {
    const labels = {
      hourly: 'Every Hour',
      daily: 'Once a Day',
      weekly: 'Once a Week',
      monthly: 'Once a Month'
    };
    return labels[frequency as keyof typeof labels] || frequency;
  };

  const handleSelectAll = (checked: boolean) => {
    updates.forEach(update => onCheckboxChange(checked, update.id));
  };

  const allSelected = updates.length > 0 && selectedUpdates.length === updates.length;

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[50px]">
            <Checkbox 
              checked={allSelected}
              onCheckedChange={handleSelectAll}
              aria-label="Select all"
            />
          </TableHead>
          <TableHead>Country</TableHead>
          <TableHead>League</TableHead>
          <TableHead>Season</TableHead>
          <TableHead>Frequency</TableHead>
          <TableHead>Last Updated</TableHead>
          <TableHead>Active</TableHead>
          <TableHead>Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {updates?.map((update) => (
          <TableRow key={update.id}>
            <TableCell>
              <Checkbox
                checked={selectedUpdates.includes(update.id)}
                onCheckedChange={(checked: boolean) => onCheckboxChange(checked, update.id)}
              />
            </TableCell>
            <TableCell>{update.country}</TableCell>
            <TableCell>{update.league.replace(/^\d+\s*/, '')}</TableCell>
            <TableCell>{update.season}</TableCell>
            <TableCell>{getFrequencyLabel(update.update_frequency)}</TableCell>
            <TableCell>
              {update.last_updated 
                ? new Date(update.last_updated).toLocaleString()
                : 'Never'}
            </TableCell>
            <TableCell>
              <Switch
                checked={update.is_active}
                onCheckedChange={(checked) => onToggleActive(update.id, checked)}
              />
            </TableCell>
            <TableCell>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onEdit(update)}
              >
                <Pencil className="h-4 w-4" />
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
